import styled from 'styled-components';
import { PALETTE } from '../../fields.constants';

export const Card = styled.section`
  padding: 16px;
  background: #fff;
  border: 1px solid ${PALETTE.line};
  border-radius: 6px;
`;

export const Title = styled.h3`
  margin: 0 0 12px;
  font-size: 15px;
  font-weight: 500;
  color: ${PALETTE.ink};
`;

export const Count = styled.span`
  font-weight: 400;
  color: ${PALETTE.muted};
`;

export const List = styled.div`
  max-height: 260px;
  margin: 0 -6px;
  overflow-y: auto;
`;

export const Row = styled.button`
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 10px;
  align-items: center;
  width: 100%;
  padding: 8px;
  text-align: left;
  background: none;
  border: none;
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    background: ${PALETTE.panel};
  }

  &[aria-current='true'] {
    background: #fffbea;
    box-shadow: inset 2px 0 0 #f2c500;
  }
`;

export const Dot = styled.span`
  width: 10px;
  height: 10px;
  background: ${({ $color }) => $color};
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 50%;
`;

export const Size = styled.span`
  display: block;
  font-size: 13.5px;
  color: ${PALETTE.ink};
`;

export const Meta = styled.span`
  display: block;
  font-size: 11.5px;
  color: ${PALETTE.muted};
`;

export const RedTag = styled.span`
  padding: 2px 8px;
  font-size: 11.5px;
  color: #d32a20;
  background: #fdecea;
  border: 1px solid #f0b4ae;
  border-radius: 999px;
`;

export const Message = styled.div`
  padding: 8px;
  font-size: 13px;
  color: ${PALETTE.muted};
`;
